var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.83337 42.1665H42.1667",
    stroke: "#00CFC5",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.65417 42.1666L5.75001 19.109C5.75001 17.9399 6.30584 16.8283 7.22584 16.1L20.6425 5.65412C22.0225 4.58079 23.9584 4.58079 25.3575 5.65412L38.7742 16.0808C39.7134 16.8091 40.25 17.9207 40.25 19.109V42.1666",
    stroke: "#00CFC5",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7083 21.0835H16.2916C14.7008 21.0835 13.4166 22.3677 13.4166 23.9585V42.1668H32.5833V23.9585C32.5833 22.3677 31.2991 21.0835 29.7083 21.0835Z",
    stroke: "#00CFC5",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1666 31.146V34.021",
    stroke: "#00CFC5",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.125 14.375H25.875",
    stroke: "#00CFC5",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReal);
export default __webpack_public_path__ + "static/media/real.11e0b7d8642d8aad96c499001e5d292e.svg";
export { ForwardRef as ReactComponent };